module.exports = __webpack_public_path__ + "images/external_images/svg/icons/019-idea.svg";